import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { BsCoin } from "react-icons/bs";
import { ImTarget } from "react-icons/im";
import { FaChartLine } from "react-icons/fa";
import aboutHero from "../../assets/img/healthh.png";
import inspiration from "../../assets/img/health2.png";
import infrastructure from "../../assets/img/healthh.png";
import incrediants from "../../assets/img/health1.png";
import cultivation from "../../assets/img/health3.png";
import AboutCard from "./AboutCard";

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fullViewInspiration = () => {
    Swal.fire({
      title: "INSPIRATION",
      text: "In 2020 while most of us had to face the pandemic, we were in need of natural healthy products for our kids to improve the immunity.But we had access to only few and others were not available. So we started to cultivate on our own to satisfy our own needs. We have studied and analysed the benefits of most precious nature’s resources and started to made it available in our daily busy life.We constantly strive to develop products that are natural, safe, gentle, effective and yet environment friendly. We continually seek new techniques and ingredients to ensure that we offer the best possible natural and cost effective products to our consumers.",
    });
  };

  const fullViewInfrastructure = () => {
    Swal.fire({
      title: "INFRASTRUCTURE",
      text: "Our farm is located about 120 kms from Chennai that expands the landscape of about 2.5 Acers own Land. (15 Acers Leased Out) Hence it makes us feasible to cultivate all our ingredients in our farm that is free from Pesticides",
    });
  };

  const fullViewIngrediants = () => {
    Swal.fire({
      title: "INGREDIANTS AND FREE OF HARMFUL CHEMICALS",
      text: "We follow the jannu's Food Productsquality Ingredients Standard in all our proprietary formulations. We work hard to ensure that every ingredient delivers lasting results naturally. We are against using ingredients that promise quick results but are harmful to the skin in the long run. Then Free from petrochemicals, parabens, Genetically modified ingredients and other synthetic ingredients.",
    });
  };

  const fullViewCultivation = () => {
    Swal.fire({
      title: "CULTIVATION",
      text: "We use the highest possible concentration of organic and wild crafted(harvested from their natural or “wild” habitat, for food or medicinal purposes) ingredients in every treatment, and use cold-pressed, certified organic plant oils as the base whereve possible.Plants in jannu's Food Products are grown in their ideal habitats, which allow them to thrive and their essences to reach peak potential.",
    });
  };

  return (
    <>
      <section class="py-5" style={{ backgroundColor: "#e0e0e0" }}>
        <div class="container">
          <div class="row align-items-center py-5">
            <div class="col-md-8 text-white">
              <h1 className="text-success">About Us</h1>
              <p className="text-dark">
                At Sri Managalambika store, we believe that cooking is more than
                just preparing meals—it’s a connection to tradition, nature, and
                health. Our journey began with a simple idea: to bring back the
                lost art of cooking with handcrafted, organic, and traditional
                cookware that enhances flavors while preserving health. Our
                Roots Nestled in the heart of kumbakonam, our story is inspired
                by the wisdom of our ancestors, who used pure clay pots, cast
                iron skillets, and stoneware to prepare meals rich in nutrition.
                We saw how modern, synthetic cookware was replacing these
                time-tested materials, and we knew it was time to revive the
                tradition. What We Do We source and craft 100% natural,
                toxin-free cookware made from clay, iron, bronze, and soapstone.
                Every piece is carefully designed to retain nutrients, enhance
                taste, and promote healthy cooking. Our products are made using
                eco-friendly processes, supporting artisans who have kept this
                craftsmanship alive for generations.
              </p>
            </div>
            <div class="col-md-4">
              <img src={aboutHero} alt="About Hero" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>
      <section class="container py-3">
        <div class="row text-center pt-5 pb-3">
          <div class="col-lg-12 m-auto">
            <h1 class="h1">Our Story</h1>
            <p>
              Pure & Authentic – No harmful chemicals or coatings. Just nature’s
              best. Handcrafted by Artisans – Each piece carries a story of
              skill and heritage. Eco-Friendly & Sustainable – Good for you,
              good for the planet. Enhances Taste & Health – Retains nutrients
              and natural flavors. At Sri Managalambika store, we are not just
              selling cookware—we are reviving a healthier, tastier, and more
              sustainable way of life. Join us in bringing tradition back to
              your kitchen!
            </p>
          </div>
        </div>
      </section>
      <section class="container py-1">
        <Row>
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <AboutCard
              image={inspiration}
              cardStyle="aboutCard"
              title="Inspiration"
              contents="In 2020 while most of us had to face the pandemic, we were in need of natural healthy products..."
              readMore={() => fullViewInspiration()}
            />
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <AboutCard
              image={infrastructure}
              cardStyle="aboutCard"
              title="Infrastructure"
              contents="Our farm is located about 120 kms from Chennai that expands the
              landscape..."
              readMore={() => fullViewInfrastructure()}
            />
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <AboutCard
              image={incrediants}
              cardStyle="aboutCard"
              title="Ingredients Standard"
              contents="We follow the jannu's Food Products quality Ingredients Standard in all our
              proprietary formulations..."
              readMore={() => fullViewIngrediants()}
            />
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <AboutCard
              image={cultivation}
              cardStyle="aboutCard"
              title="Cultivation"
              contents="We use the highest possible concentration of organic and wild crafted.."
              readMore={() => fullViewCultivation()}
            />
          </Col>
        </Row>
        <div class="row d-flex justify-content-center my-3">
          <div class="col-md-4 col-lg-4">
            <div class="px-5 services-icon-wap">
              <div class="h1 aboutIcon text-center">
                <ImTarget />
              </div>
              <h2 class="h5 mt-4 text-center">Mission</h2>
              <p
                style={{
                  textAlign: "justify",
                  fontSize: "15px",
                  fontWeight: "400",
                }}
              >
                Plants in jannu's Food Products are grown in their ideal
                habitats, which allow them to thrive and their essences to reach
                peak potential.
              </p>
            </div>
          </div>

          <div class="col-md-4 col-lg-4">
            <div class="px-5 services-icon-wap">
              <div class="h1 aboutIcon text-center">
                <FaChartLine />
              </div>
              <h2 class="h5 mt-4 text-center">Vision</h2>
              <p
                style={{
                  textAlign: "justify",
                  fontSize: "15px",
                  fontWeight: "400",
                }}
              >
                Currently we have launched skin/hair care products and
                fertilizers. By 2023 we are planning to emerge into various
                products such as food products, vegetables, fruits, pulses, etc
              </p>
            </div>
          </div>

          <div class="col-md-4 col-lg-4">
            <div class="px-5 services-icon-wap">
              <div class="h1 aboutIcon text-center">
                <BsCoin />
              </div>
              <h2 class="h5 mt-4 text-center">Values</h2>
              <p
                style={{
                  textAlign: "justify",
                  fontSize: "15px",
                  fontWeight: "400",
                }}
              >
                We Sell the Highest Quality Natural and Organic products We
                satisfy and delight our customers Right product at the right
                quantity with right quality at right time.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
